module.exports = __webpack_public_path__ + "static/media/unibestWeb3.8bb73f5e.png";